import { MathJax } from 'better-react-mathjax';
import React from 'react';
import { useSelector } from 'react-redux';

import { getUserType } from 'redux/slices/userSlice';

import { StudentMathFormula } from './ui';
import { ICL, TaskKeysType, MathFormulasTask, Formula } from '../../../shared/types';
import StudentTaskWrapper from '../StudentTaskWrapper';

interface StudentMathFormulasTaskProps extends MathFormulasTask {
  icl: ICL | null;
  handleChangeTaskByKey: (id: string, key: TaskKeysType, value: string[] | string | boolean | Formula[]) => void;
  saveTaskAnswer: (id: string) => Promise<void>;
  hw?: boolean;
  preview?: boolean;
  studentName?: string;
  index: number;
}

export default function StudentMathFormulasTask({
  icl,
  text,
  subText,
  answer,
  hasAnswer,
  hasStar,
  checkedAt,
  completedAt,
  handleChangeTaskByKey,
  id,
  hasPhoto,
  answersPhotos,
  saveTaskAnswer,
  deadline,
  audioUrl,
  videoUrl,
  taskPhotos,
  editedAnswerPhotos,
  hw,
  pdfUrl,
  wordUrl,
  studentPdfUrl,
  studentWordUrl,
  preview,
  formulas,
  studentName,
  index,
}: StudentMathFormulasTaskProps) {
  const userType = useSelector(getUserType);

  const changeFormikMathFormula = (currentFormula: Formula) => {
    const changedFormulas = formulas.map(formula => (formula.id === currentFormula.id ? currentFormula : formula));

    handleChangeTaskByKey(id, 'formulas', changedFormulas);
  };

  const areStudentAnswers = formulas.every(formula => (formula.formula.includes('?') ? !!formula.answer : true));
  const isDisabledSubmitButton = !areStudentAnswers || !!checkedAt || !!completedAt;

  const isStudent = userType === 'Student';
  const isInputDisabled = !!checkedAt || !!completedAt || !isStudent || !!preview;

  return (
    <StudentTaskWrapper
      icl={icl}
      taskText={text}
      answersPhotos={answersPhotos}
      id={id}
      handleChangeTaskByKey={handleChangeTaskByKey}
      checkedAt={checkedAt}
      hasPhoto={hasPhoto}
      completedAt={completedAt}
      saveTaskAnswer={saveTaskAnswer}
      deadline={deadline}
      audioUrl={audioUrl}
      answer={answer}
      hasAnswer={hasAnswer}
      hasStar={hasStar}
      videoUrl={videoUrl}
      taskPhotos={taskPhotos}
      editedAnswerPhotos={editedAnswerPhotos}
      hw={hw}
      pdfUrl={pdfUrl}
      wordUrl={wordUrl}
      studentPdfUrl={studentPdfUrl}
      studentWordUrl={studentWordUrl}
      preview={preview}
      subText={subText}
      isDisabledSubmitButton={isDisabledSubmitButton}
      isSubmitButton
      studentName={studentName}
      index={index}
    >
      <ul className="flex flex-col gap-3 py-[20px] lg:gap-4 lg:py-8">
        {formulas.map(formula => (
          <li key={formula.id}>
            {formula.formula.includes('?') ? (
              <StudentMathFormula
                formula={formula}
                isInputDisabled={isInputDisabled}
                changeFormikMathFormula={changeFormikMathFormula}
              />
            ) : (
              <MathJax>{formula.formula}</MathJax>
            )}
          </li>
        ))}
      </ul>
    </StudentTaskWrapper>
  );
}
